/**
 * Cartiq's versioned, local snapshot of Tuolen's visual identity.
 *
 * Source: Tuolen's product-theme.css / brand-experience.css and app index.css,
 * reviewed 2026-10-10. See README.md for provenance and the intentional mapping
 * from Cartiq's legacy `primary` (ink) / `accent` (action) token names.
 * No runtime or build-time dependency on the Tuolen app is required.
 */
export const TUOLEN_BRAND = Object.freeze({
  version: 1,
  name: 'Cartiq',
  fullName: 'Cartiq by Tuolen',
  parentName: 'Tuolen',
  colors: Object.freeze({
    primary: '#134A76',
    primaryHover: '#082F4C',
    ink: '#092D48',
    primarySoft: '#EAF3F9',
    dark: '#082C46',
    highlight: '#3278A3',
    sky: '#9BD7FF',
    background: '#FCFCFC',
    surface: '#F8FAFB',
    card: '#FFFFFF',
    muted: '#586E7C',
    border: '#DCE6EC',
    onPrimary: '#FFFFFF',
    success: '#16A34A',
    warning: '#F59E0B',
    error: '#EF4444',
  }),
  fonts: Object.freeze({
    sans: Object.freeze(['Inter', 'system-ui', '-apple-system', 'sans-serif']),
    editorial: Object.freeze(['Georgia', '"Times New Roman"', 'serif']),
  }),
  radius: Object.freeze({ sm: '6px', md: '8px', lg: '10px', xl: '12px', '2xl': '16px' }),
  sidebar: Object.freeze({
    DEFAULT: 'hsl(0 0% 98.5%)',
    foreground: 'hsl(220 16% 36%)',
    border: 'hsl(220 13% 91%)',
    accent: 'hsl(215 20% 94%)',
    'accent-foreground': 'hsl(215 25% 27%)',
    muted: 'hsl(220 12% 55%)',
  }),
  assets: Object.freeze({
    mark: '/brand/tuolen-mark.png',
    markWhite: '/brand/tuolen-mark-white.png',
    favicon: '/brand/tuolen-favicon.png',
    appleTouch: '/brand/tuolen-apple-touch.png',
  }),
});
